var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "nba-primary grid grid__base" }, [
    _c("div", { staticClass: "nba-primary--container grid--container" }, [
      _c("div", { staticClass: "nba-primary--row grid--row" }, [
        _c(
          "div",
          {
            staticClass:
              "nba-primary--content-wrapper nba-primary--content-wrapper-left"
          },
          [
            _c(
              "div",
              { staticClass: "nba-primary--content nba-primary--content-left" },
              [_vm._t("content-left")],
              2
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "nba-primary--content-wrapper nba-primary--content-wrapper-right"
          },
          [
            _c(
              "div",
              {
                staticClass: "nba-primary--content nba-primary--content-right"
              },
              [_vm._t("content-right")],
              2
            )
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "nba-primary--background" })
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6e28257e", { render: render, staticRenderFns: staticRenderFns })
  }
}